import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import ReactTable from "react-table";
import Select from 'react-select';
import { zunpulseOrderColumns } from '../../config/column_fields';
import Header from '../../components/HeaderComponent';
import { getSearchResult } from '../../actions/searchAction';
import { fetchPreSalesMetrics } from '../../actions/whatsAppActions.js';
import moment from 'moment';
import swal from 'sweetalert';


class WhatsAppPreSalesMetrics extends Component {

  constructor(props) {
    super(props);
    this.state = {
      metricsData : [],
      loading : true,
      filterData : {},
      languages : [{ value: "English", label: "English" }, { value: "Hindi", label: "Hindi" }, { value: "Telugu", label: "Telugu" }, { value: "Gujarati", label: "Gujarati" }, { value: "Kannada", label: "Kannada" }],
    };
    this.statusMap = ["Not Ordered", "Ordered", "Shipped", "Delivered"];
  }

  componentWillMount() {
    this.props.fetchPreSalesMetrics();
  }

  componentWillReceiveProps(props) {
    let { whatsAppMetricsData = [] } = props;
    this.setState({
      metricsData: whatsAppMetricsData.data || [],
      loading : false
    })
  }

  dateType = (name, value, field) => {
    return (
      <div class="form-group">
        <span class="dateSideBar" />
        <input name={name} style={{ width: "100%" }} className="form-control" type="date" onChange={(e) => { this.handleDateChange(e, field) }} value={value}></input>
      </div>
    )
  }

  handleDateChange = (e, field) => {
    let { name, value } = e.target
    this.setState({
      filterData: {
        ...this.state.filterData,
        [field]: {
          ...this.state.filterData[field] ? this.state.filterData[field] : {},
          [name]: value
        }
      },
      page: 1
    });
  }

  multiSelectType = (name, options, placeholder, value, isMulti = true) => {
    return (
      <div className="form-group" style={{ width: '100%' }}>
        <Select
          isMulti = {isMulti}
          isSearchable
          onChange={(e) => { this.handleMultiSelectChange(e, name) }}
          placeholder={placeholder}
          name={name}
          options={options}
        />
      </div>
    )
  }

  handleMultiSelectChange = (e, name) => {
    let selectedList;
    if (Array.isArray(e)) {
      selectedList = (e || []).map((data) => {
        return data.value
      });
      if (selectedList.length <= 1) {
        selectedList = selectedList[0]
      }
    } else {
      selectedList = (e || {}).value || undefined
    }
    if (name == "messageType") {
      selectedList = { [name] : selectedList};
    }
    this.setState({
      filterData: {
        ...this.state.filterData,
        [name]: selectedList
      },
      page: 1
    })
  }

  removingNullKeys = (obj) => {

    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName].length < 1 || obj[propName] == "" || obj[propName] == {}) {
        delete obj[propName];
      }
    }

    return obj
  }

  onApplyFilter = (e) => {
    let filterData = { ...this.state.filterData }
    filterData = JSON.parse(JSON.stringify(filterData));
    let filterObj = this.removingNullKeys(filterData);
    console.log("Naman", filterObj);
    if (Object.keys(filterObj).length > 0) {
      this.props.fetchPreSalesMetrics(filterObj);
      this.setState({
        // filterObj: filterObj
      })
    } else {
      swal("Please apply atleast one filter")
    }
  }

  render() {
    // console.log("100", Object.values(this.state.ordersData))
    let { metricsData } = this.state;
    const columns = [
      {
        Header : "Month",
        accessor : "startDate"
      },
      {
        Header : "Total Leads",
        accessor : "totalCount"
      },
      {
        Header : "Conversations",
        accessor : "conversationCount",
        Cell: row => {
          return `${row.value} (${row.original.conversationPercentage}%)`
        }
      },
      {
        Header : "New Info",
        accessor : "newInfoCount",
        Cell: row => {
          return `${row.value} (${row.original.newInfoPercentage}%)`
        }
      },
      {
        Header : "Booked SA",
        accessor : "bookedSACount",
        Cell: row => {
          return `${row.value} (${row.original.bookedSAPercentage}%)`
        }
      },
      {
        Header : "QuoteId",
        accessor : "quoteIdCount",
        Cell: row => {
          return `${row.value} (${row.original.quoteIdPercentage}%)`
        }
      }
    ]
    return (
      <div>
        <Header getSearchResult={this.props.getSearchResult} />
        <div style={{ "marginTop": 80 }} className="container-fluid">
          <div>
            <div className="topbar-section allLeadViewFilters">
              <div className="col-md-4"><b>Filters</b></div>
              <hr></hr>
              <div className="row">
                <div className="col-md-2">
                  <label>Created On Start</label>
                  {this.dateType("startDate", this.state.filterData.createdOn ? this.state.filterData.createdOn.startDate : "", "createdOn")}
                </div>
                <div className="col-md-2">
                  <label>Created On End</label>
                  {this.dateType("endDate", this.state.filterData.createdOn ? this.state.filterData.createdOn.endDate : "", "createdOn")}
                </div>
                <div className="col-md-2">
                  <label>Language</label>
                  {this.multiSelectType("language", this.state.languages, "Language", this.state.filterData.language)}
                </div>
                <div>
                  <label></label><br></br>
                  <button onClick={this.onApplyFilter} className="btn btn-success">Apply filter</button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <ReactTable
            filterable={true}
            showPagination={false}
            sortable={true}
            data={metricsData}
            columns={columns}
            pageSize={this.state.metricsData.length}
            defaultFilterMethod={(filter, row) => String(row[filter.id]).toLowerCase().indexOf(filter.value.toLowerCase()) > -1}
            loading={this.state.loading}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log("state", state)
  let { whatsAppMetricsData } = state;
  return {
    whatsAppMetricsData
  }
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchPreSalesMetrics }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppPreSalesMetrics);
